'use strict'

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './Loader.less'

const SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large'
}
class Loader extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      size: props.size
    }
  }

  componentWillReceiveProps (props) {
    this.setState({size: props.size})
  }

  componentDidMount () {
    this.setToLargeIfNeeded()
  }

  componentDidUpdate () {
    this.setToLargeIfNeeded()
  }

  setToLargeIfNeeded = () => {
    if (this.state.size === SIZES.medium && this.props.timeToLargeLoader && !this.setLargeTimer) {
      this.clearLargeTimer()
      const {timeToLargeLoader} = this.props
      this.setLargeTimer = setTimeout(this.setToLargeLoader, timeToLargeLoader)
    }
  }

  clearLargeTimer = () => {
    if (this.setLargeTimer) {
      clearTimeout(this.setLargeTimer)
      this.setLargeTimer = null
    }
  }

  setToLargeLoader = () => {
    this.clearLargeTimer()
    this.setState({size: SIZES.large})
  }

  render () {
    const {loadingHeader, loadingText} = this.props
    const {size} = this.state
    const className = classnames('nmc-loader', {
      'nmc-loader-small': size === SIZES.small,
      'nmc-loader-medium': size === SIZES.medium,
      'nmc-loader-large': size === SIZES.large
    })

    if (size === SIZES.large) {
      return <div className={className}>
        <div className='nmc-loader-large-header'>{loadingHeader}</div>
        <div className='nmc-loader-medium' />
        <div className='nmc-loader-large-text'>{loadingText}</div>
      </div>
    } else {
      return <div className={className} />
    }
  }
}

Loader.propTypes = {
  size: PropTypes.oneOf([SIZES.small, SIZES.medium, SIZES.large]).isRequired,
  loadingText: PropTypes.string,
  loadingHeader: PropTypes.string,
  timeToLargeLoader: PropTypes.number
}

Loader.defaultProps = {
  size: SIZES.medium,
  loadingHeader: 'thinking',
  loadingText: 'this may take a moment',
  timeToLargeLoader: null
}

export default Loader



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Loader/index.js